import axios from "axios";
import qs from "qs";
import XRegExp from "xregexp";

var runFieldActionLock = false;
var saveStateLock = false;

function data2field(data) {
  return {
    ...data,
    fields: data.fields
      ? Object.keys(data.fields).map(name =>
        data2field({
          name: name,
          ...data.fields[name]
        })
      )
      : null
  };
}

function field2data(field) {
  return {
    fields: field.fields
      ? field.fields
             .filter(field => field.name)
             .reduce((fields, field) => {
               fields[field.name] = field2data(field);
               return fields;
             }, {})
      : null,
    value: field.value
  };
}

const runFieldAction = (state, { field, action }) => {
  if (runFieldActionLock) {
    return;
  }
  runFieldActionLock = true;

  axios
    .post(
      action.api,
      qs.stringify({
        ...state.state.api.params,
        ...field2data(field)
      })
    )
    .then(response => {
      runFieldActionLock = false;

      if (response.data.body && response.data.body.goToMagicRetrieve) {
        window.location.href = response.data.body.goToMagicRetrieve;
      }

      if (window.onCheckout && window.onCheckout.runFieldAction) {
        window.onCheckout.runFieldAction(action, field2data(state.state));
      }

      state.dispatch("updateField", {
        field: field,
        newProps: data2field(response.data.body)
      });
    })
    .catch(error => {
      runFieldActionLock = false;
    });
};

const updateField = (state, { field, newProps }) => {
  state.commit("updateField", {
    field: field,
    newProps: newProps
  });

  if (!field.fields) {
    return;
  }
  if (!newProps.fields) {
    return;
  }

  newProps.fields.forEach(newSubProps => {
    field.fields
         .filter(field => field.name === newSubProps.name)
         .forEach(field => {
           state.dispatch("updateField", {
             field: field,
             newProps: newSubProps
           });
         });
  });
};

const validateField = (state, { field }) => {
  state.dispatch("updateField", {
    field: field,
    newProps: {
      error: null,
      valid: null
    }
  });

  if (field.disabled) {
    return;
  }

  let isValid = field.validator
    ? XRegExp(field.validator.pattern).test(field.value ? field.value : "")
    : true;

  state.dispatch("updateField", {
    field: field,
    newProps: {
      error: isValid ? null : field.validator.error,
      valid: isValid
    }
  });

  if (!isValid) {
    return;
  }
  if (!field.fields) {
    return;
  }

  let childFields = field.fields.filter(
    childField =>
      field.type !== "conditional" || field.value === childField.name
  );

  if (!childFields) {
    return;
  }

  childFields.forEach(childField => {
    state.dispatch("validateField", {
      field: childField
    });
  });

  let isChildValid = childFields.reduce(
    (isValid, childField) => isValid && childField.valid !== false,
    true
  );

  state.dispatch("updateField", {
    field: field,
    newProps: {
      error: isValid ? null : field.validator.error,
      valid: isValid && isChildValid
    }
  });
};

const loadState = (state, { newState }) => {
  let setup = function (field, parent) {
    field.error = null;
    field.path = parent ? [...parent.path, field.name] : [field.name];
    field.valid = null;

    if (field.fields) {
      field.fields.forEach(child => setup(child, field));
    }

    return field;
  };

  state.commit("updateState", {
    newState: setup(newState)
  });
};

const saveState = state => {
  state.dispatch("updateSteps", {
    activeIndex: state.state.steps.length
  });

  if (state.state.fields.some(field => field.valid === false)) {
    return;
  }

  if (saveStateLock) {
    return;
  }
  saveStateLock = true;

  axios
    .post(
      state.state.api.save,
      qs.stringify({
        ...state.state.api.params,
        ...field2data(state.state)
      })
    )
    .then(response => {
      if (response.data.body.goto) {
        if (window.onCheckout && window.onCheckout.saveState) {
          window.onCheckout.saveState(response.data, field2data(state.state));
        }

        window.location.href = response.data.body.goto;
        return;
      }

      saveStateLock = false;

      let newState = response.data.body;

      state.commit("updateState", {
        newState: {
          ...state.state,
          ...{
            messages: {
              error: [newState.msg]
            }
          }
        }
      });

      if (response.data.body && response.data.body.fields) {
        state.dispatch("updateField", {
          field: state.state,
          newProps: data2field(response.data.body)
        });

        state.dispatch("updateSteps", {
          activeIndex: state.state.steps.length
        });
      }
    })
    .catch(error => {
      saveStateLock = false;
    });
};

const updateSteps = (state, { activeIndex }) => {
  let currentFields = state.state.steps
                           .slice(0, activeIndex)
                           .map(step => step.fieldNames)
                           .flat()
                           .map(fieldName =>
                             state.state.fields.find(field => field.name === fieldName)
                           )
                           .filter(field => field && !field.disabled);

  let autosubmit = currentFields
    .filter(field => field.type === "process" && field.value !== "completed")
    .filter(field => field.autosubmit);

  if (autosubmit.length > 0) {
    autosubmit.forEach(field => {
      let action = field.actions.find(action => action.name === field.value);

      state.dispatch("runFieldAction", {
        field: field,
        action: action
      });
    });

    return;
  }

  currentFields.forEach(field => {
    state.dispatch("validateField", {
      field: field
    });
  });

  if (currentFields.some(field => field.valid === false)) {
    let invalidFieldNames = currentFields
      .filter(field => field.valid === false)
      .map(field => field.name);

    let firstInvalidStep = state.state.steps
                                .map((step, index) => {
                                  return {
                                    index: index,
                                    invalid: step.fieldNames.some(fieldName =>
                                      invalidFieldNames.includes(fieldName)
                                    )
                                  };
                                })
                                .filter(step => step.invalid)
                                .map(step => step.index)
                                .shift();

    state.commit("updateSteps", {
      activeIndex: firstInvalidStep
    });

    return;
  }

  if (window.onCheckout && window.onCheckout.upadateSteps) {
    window.onCheckout.upadateSteps(activeIndex, field2data(state.state));
  }

  state.commit("updateSteps", {
    activeIndex: activeIndex
  });
};

export default {
  runFieldAction,
  updateField,
  updateSteps,
  validateField,
  loadState,
  saveState
};
